/* Crafty Bonobo rebuild — the lead-journey events the brief asks to measure.
   Sends to GA4 (gtag) when present, to Shopify's web pixels (custom events), and to the dataLayer. */
(function () {
  function send(name, params) {
    params = params || {};
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('cb_' + name, params); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
  }
  var started = {};
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="tel:"]'); if (a) send('phone_click', { location: location.pathname });
    if (e.target.closest && e.target.closest('#wa-icon-btn')) send('whatsapp_click', { location: location.pathname });
  }, true);
  document.addEventListener('focusin', function (e) {
    var f = e.target.closest && e.target.closest('form');
    if (!f || started[f.id || f.action]) return;
    if (/ops\.thecraftybonobo\.com\/api\/forms/.test(f.action)) { started[f.id || f.action] = 1; send('quote_start', { form: (f.querySelector('[name="Enquiry source"]') || {}).value || (new URL(f.action).searchParams.get('form')) || 'enquiry', location: location.pathname }); }
    if (e.target.closest('.cbsp')) { started[f.id || 'personaliser'] = 1; send('personaliser_start', { product: location.pathname }); }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.type === 'file' && e.target.files && e.target.files.length) send('file_upload', { form: (e.target.closest('form') || {}).id || '', bytes: e.target.files[0].size, type: e.target.files[0].type });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (/ops\.thecraftybonobo\.com\/api\/forms/.test(f.action)) send('quote_submit', { form: (new URL(f.action).searchParams.get('form')) || (f.querySelector('[name="Enquiry source"]') || {}).value || 'enquiry' });
    if (f.classList && f.classList.contains('cbsp__form')) send('personaliser_add_to_basket', { product: location.pathname });
  }, true);
})();
